// 定义英文语言包对象
// 英语
exports.default = {
    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'Clear'
        }
    }
};
